import {httpClient} from '@/api/baseApi';

let cached: Promise<any> | null = null;

export function getVersion(): Promise<any> {
  if (!cached) {
    cached = httpClient.get('version').then(res => res.data);
  }
  return cached;
}
